import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["ref"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Suspense } from 'react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { GiveKudosLauncherLazy, KudosType } from '@atlaskit/give-kudos';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import Popup from '@atlaskit/popup';
import { layers } from '@atlaskit/theme/constants';
import _filterActions from '../../internal/filterActions';
import { CardWrapper } from '../../styled/Card';
import { cardTriggered, fireEvent } from '../../util/analytics';
import { DELAY_MS_HIDE, DELAY_MS_SHOW } from '../../util/config';
import { ProfileCardLazy } from './lazyProfileCard';
import ProfilecardTriggerNext from './ProfileCardTriggerNext';
import UserLoadingState from './UserLoadingState';
var ProfilecardTrigger = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ProfilecardTrigger, _React$PureComponent);
  var _super = _createSuper(ProfilecardTrigger);
  function ProfilecardTrigger() {
    var _this;
    _classCallCheck(this, ProfilecardTrigger);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);
    _defineProperty(_assertThisInitialized(_this), "showDelay", _this.props.trigger === 'click' ? 0 : DELAY_MS_SHOW);
    _defineProperty(_assertThisInitialized(_this), "hideDelay", _this.props.trigger === 'click' ? 0 : DELAY_MS_HIDE);
    _defineProperty(_assertThisInitialized(_this), "showTimer", 0);
    _defineProperty(_assertThisInitialized(_this), "hideTimer", 0);
    _defineProperty(_assertThisInitialized(_this), "fireAnalytics", function (payload) {
      // Don't fire any analytics if the component is unmounted
      if (!_this._isMounted) {
        return;
      }
      if (_this.props.createAnalyticsEvent) {
        fireEvent(_this.props.createAnalyticsEvent, payload);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "hideProfilecard", function () {
      clearTimeout(_this.showTimer);
      clearTimeout(_this.hideTimer);
      _this.hideTimer = window.setTimeout(function () {
        _this.setState({
          visible: false
        });
      }, _this.hideDelay);
    });
    _defineProperty(_assertThisInitialized(_this), "showProfilecard", function () {
      clearTimeout(_this.hideTimer);
      clearTimeout(_this.showTimer);
      _this.showTimer = window.setTimeout(function () {
        if (!_this.state.visible) {
          _this.clientFetchProfile();
          _this.setState({
            visible: true
          });
        }
      }, _this.showDelay);
    });
    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      // If the user clicks on the trigger then we don't want that click event to
      // propagate out to parent containers. For example when clicking a mention
      // lozenge in an inline-edit.
      event.stopPropagation();
      _this.showProfilecard();
      if (!_this.state.visible) {
        _this.fireAnalytics(cardTriggered('user', 'click'));
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function () {
      _this.showProfilecard();
      if (!_this.state.visible) {
        _this.fireAnalytics(cardTriggered('user', 'hover'));
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyPress", function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        _this.showProfilecard();
        if (!_this.state.visible) {
          _this.fireAnalytics(cardTriggered('user', 'click'));
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onFocus", function () {
      _this.showProfilecard();
    });
    _defineProperty(_assertThisInitialized(_this), "containerListeners", _this.props.trigger === 'hover' ? {
      onMouseEnter: _this.onMouseEnter,
      onMouseLeave: _this.hideProfilecard,
      onBlur: _this.hideProfilecard,
      onKeyPress: _this.onKeyPress
    } : {
      onClick: _this.onClick,
      onKeyPress: _this.onKeyPress
    });
    _defineProperty(_assertThisInitialized(_this), "layerListeners", {
      handleClickOutside: _this.hideProfilecard,
      handleEscapeKeydown: _this.hideProfilecard
    });
    _defineProperty(_assertThisInitialized(_this), "state", {
      visible: false,
      isLoading: undefined,
      hasError: false,
      error: null,
      data: null,
      reportingLinesData: undefined,
      shouldShowGiveKudos: false,
      teamCentralBaseUrl: undefined,
      kudosDrawerOpen: false
    });
    _defineProperty(_assertThisInitialized(_this), "clientFetchProfile", function () {
      var _this$props = _this.props,
        cloudId = _this$props.cloudId,
        userId = _this$props.userId;
      var isLoading = _this.state.isLoading;
      if (isLoading === true) {
        // don't fetch data when fetching is in process
        return;
      }
      _this.setState({
        teamCentralBaseUrl: _this.props.resourceClient.getTeamCentralBaseUrl()
      });
      _this.setState({
        isLoading: true,
        hasError: false,
        data: null
      }, function () {
        var requests = Promise.all([_this.props.resourceClient.getProfile(cloudId || '', userId, _this.fireAnalytics), _this.props.resourceClient.getReportingLines(userId), _this.props.resourceClient.shouldShowGiveKudos()]);
        requests.then(function (res) {
          var _this2;
          return (_this2 = _this).handleClientSuccess.apply(_this2, _toConsumableArray(res));
        }, function (err) {
          return _this.handleClientError(err);
        }).catch(function (err) {
          return _this.handleClientError(err);
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "openKudosDrawer", function () {
      _this.hideProfilecard();
      _this.setState({
        kudosDrawerOpen: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "closeKudosDrawer", function () {
      _this.setState({
        kudosDrawerOpen: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderCard", function () {
      var isLoading = _this.state.isLoading;
      if (isLoading === true || isLoading === undefined) {
        return /*#__PURE__*/React.createElement(CardWrapper, null, /*#__PURE__*/React.createElement(UserLoadingState, {
          fireAnalytics: _this.fireAnalytics
        }));
      } else {
        return _this.renderProfileCard();
      }
    });
    return _this;
  }
  _createClass(ProfilecardTrigger, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
        userId = _this$props2.userId,
        cloudId = _this$props2.cloudId,
        resourceClient = _this$props2.resourceClient;
      var visible = this.state.visible;

      // just re-fetching data when the card opens
      if (visible && (userId !== prevProps.userId || cloudId !== prevProps.cloudId || resourceClient !== prevProps.resourceClient)) {
        this.setState({
          isLoading: undefined
        }, this.clientFetchProfile);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      clearTimeout(this.showTimer);
      clearTimeout(this.hideTimer);
    }
  }, {
    key: "handleClientSuccess",
    value: function handleClientSuccess(profileData, reportingLinesData, shouldShowGiveKudos) {
      if (!this._isMounted) {
        return;
      }
      this.setState({
        isLoading: false,
        hasError: false,
        data: profileData,
        reportingLinesData: reportingLinesData,
        shouldShowGiveKudos: shouldShowGiveKudos
      });
    }
  }, {
    key: "handleClientError",
    value: function handleClientError(err) {
      if (!this._isMounted) {
        return;
      }
      this.setState({
        isLoading: false,
        hasError: true,
        error: err
      });
    }
  }, {
    key: "filterActions",
    value: function filterActions() {
      return _filterActions(this.props.actions, this.state.data);
    }
  }, {
    key: "renderProfileCard",
    value: function renderProfileCard() {
      var _this$state$data;
      var newProps = _objectSpread(_objectSpread({
        userId: this.props.userId,
        isCurrentUser: (_this$state$data = this.state.data) === null || _this$state$data === void 0 ? void 0 : _this$state$data.isCurrentUser,
        clientFetchProfile: this.clientFetchProfile
      }, this.state.data), {}, {
        reportingLines: this.state.reportingLinesData,
        onReportingLinesClick: this.props.onReportingLinesClick,
        isKudosEnabled: this.state.shouldShowGiveKudos,
        teamCentralBaseUrl: this.state.teamCentralBaseUrl,
        cloudId: this.props.cloudId,
        openKudosDrawer: this.openKudosDrawer
      });
      var wrapperProps = this.props.trigger === 'hover' ? {
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.hideProfilecard,
        onFocus: this.onFocus
      } : {};
      return /*#__PURE__*/React.createElement("div", wrapperProps, this.state.visible && /*#__PURE__*/React.createElement(Suspense, {
        fallback: null
      }, /*#__PURE__*/React.createElement(ProfileCardLazy, _extends({}, newProps, {
        actions: this.filterActions(),
        hasError: this.state.hasError,
        errorType: this.state.error,
        withoutElevation: true
      }))));
    }
  }, {
    key: "renderWithTrigger",
    value: function renderWithTrigger() {
      var _this3 = this;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Popup, {
        isOpen: !!this.state.visible,
        onClose: this.hideProfilecard,
        placement: this.props.position,
        content: this.renderCard,
        trigger: function trigger(triggerProps) {
          var ref = triggerProps.ref,
            innerProps = _objectWithoutProperties(triggerProps, _excluded);
          return /*#__PURE__*/React.createElement("span", _extends({}, innerProps, _this3.containerListeners, {
            ref: ref,
            "data-testid": _this3.props.testId,
            role: "button",
            tabIndex: 0
          }), _this3.props.children);
        },
        zIndex: layers.modal(),
        shouldUseCaptureOnOutsideClick: true,
        autoFocus: this.props.trigger === 'click'
      }), this.state.shouldShowGiveKudos && /*#__PURE__*/React.createElement(Suspense, {
        fallback: null
      }, /*#__PURE__*/React.createElement(GiveKudosLauncherLazy, {
        isOpen: this.state.kudosDrawerOpen,
        recipient: {
          type: KudosType.INDIVIDUAL,
          recipientId: this.props.userId
        },
        analyticsSource: "profile-card",
        teamCentralBaseUrl: this.state.teamCentralBaseUrl,
        cloudId: this.props.cloudId,
        addFlag: this.props.addFlag,
        onClose: this.closeKudosDrawer
      })));
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.children) {
        return this.renderWithTrigger();
      } else {
        throw new Error('Component "ProfileCardTrigger" must have "children" property');
      }
    }
  }]);
  return ProfilecardTrigger;
}(React.PureComponent);
_defineProperty(ProfilecardTrigger, "defaultProps", {
  actions: [],
  trigger: 'hover',
  position: 'bottom-start'
});
var ProfilecardTriggerLegacy = withAnalyticsEvents()(ProfilecardTrigger);
export default function ProfilecardTriggerSwitch(props) {
  return getBooleanFF('platform.profile-card-trigger-next') ? /*#__PURE__*/React.createElement(ProfilecardTriggerNext, _extends({}, props, {
    onVisibilityChange: function onVisibilityChange(isVisible) {
      if (props.onVisibilityChange) {
        props.onVisibilityChange(isVisible);
      }
    }
  })) : /*#__PURE__*/React.createElement(ProfilecardTriggerLegacy, props);
}